import type { FC } from "react";
import DatePicker from "react-multi-date-picker";
import Persian from "react-date-object/calendars/persian";
import PersianFa from "react-date-object/locales/persian_fa";

interface IProps {
  label: string;
  name: string;
  placeholder: string;
  onChange: (date: any) => void;
  value: any[];
}

const DateComponent: FC<IProps> = ({
  label,
  name,
  placeholder,
  onChange,
  value,
}) => {
  return (
    <div>
      <label className="tw-font-bold tw-text-[13px] xxxl:tw-text-[17.33px] tw-text-[#344456] tw-block">
        {label}
      </label>
      <DatePicker
        name={name}
        onChange={onChange}
        containerStyle={{ display: "block", marginTop: "14px" }}
        format={"YYYY/MM/DD"}
        range
        calendar={Persian}
        locale={PersianFa}
        render={(_, openClendar) => {
          return (
            <div className="tw-relative">
              <input
                placeholder={placeholder}
                onFocus={openClendar}
                className="tw-block tw-w-full tw-h-full tw-px-4 tw-py-4 tw-rounded-md !tw-border !tw-border-[#344456]/20"
                style={{ outline: "0px none" }}
                // value={value}
                value={value?.join?.(" ~ ") || ""}
                // value={getValues().fromPublisheDate ? isEN ? getValues().fromPublisheDate?.toString() : DateUtils.parsePersianhNewsDate(getValues().fromPublisheDate?.toString()) : ""}
                // value={getValues().fromPublisheDate ? getValues().fromPublisheDate?.toString() : ""}
              />
            </div>
          );
        }}
      />
    </div>
  );
};

export default DateComponent;
